import { useEffect, useState } from 'react'
import { X } from 'lucide-react'
import PageHero from '../components/PageHero'
import { galleryImages } from '../data/gallery'
import type { GalleryImage } from '../types/content'
import { useSeo } from '../hooks/useSeo'

export default function GalleryPage() {
  useSeo({
    title: 'Gallery | Em Whell Motorsport',
    description: 'Photos from the track, podiums and preparation — the story of Em Whell Motorsport and the #7 Production Sedan.',
    path: '/gallery',
    image: '/assets/em-car-night.jpg',
  })
  const [selected, setSelected] = useState<GalleryImage | null>(null)

  useEffect(() => {
    if (!selected) return
    const handleKey = (event: KeyboardEvent) => {
      if (event.key === 'Escape') setSelected(null)
    }
    document.body.classList.add('menu-open')
    window.addEventListener('keydown', handleKey)
    return () => {
      document.body.classList.remove('menu-open')
      window.removeEventListener('keydown', handleKey)
    }
  }, [selected])

  return (
    <>
      <PageHero eyebrow="Gallery" title="Life around" highlight="the #7." copy="Track action, podium moments, preparation and the people behind Em Whell Motorsport." image="/assets/em-car-night.jpg" imageWidth={1080} imageHeight={810} />
      <section className="section"><div className="site-container gallery-page-grid">{galleryImages.map((image, index) => <button type="button" key={image.src} className={index % 5 === 0 ? 'wide' : ''} onClick={() => setSelected(image)}><img src={image.src} alt={image.alt} width={image.width} height={image.height} loading={index === 0 ? 'eager' : 'lazy'} /><span>{image.caption}</span></button>)}</div></section>
      {selected && <div className="lightbox" role="dialog" aria-modal="true" aria-label={selected.caption}><button type="button" onClick={() => setSelected(null)} aria-label="Close image"><X /></button><img src={selected.src} alt={selected.alt} width={selected.width} height={selected.height} /><p>{selected.caption}</p></div>}
    </>
  )
}
